import type { TournamentsApi } from '@/v2/api/metadata/tournaments'
import { createFeedConfigDialogApi } from '@/v2/kits/feed-config'
import { tournamentId } from '../../shared'

export function createTournamentFeedConfigApi(tournaments: TournamentsApi) {
  return createFeedConfigDialogApi(({ values }) => tournamentId(values), {
    getFeedTypeMappings: tournaments.getFeedTypeMappings.bind(tournaments),
    getFeedInstanceMappings: tournaments.getFeedInstanceMappings.bind(tournaments),
    updateEntity: async (entityId, payload) => {
      await tournaments.update(entityId, payload)
    },
  })
}
